import PriceWithdrawlAddForm from './PriceWithdrawlAddForm';

export default PriceWithdrawlAddForm;
